import MailSvg from '@assets/images/svg/mail.svg';
import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';

export interface MailIconProps {
  size?: number;
  width?: number;
  height?: number;
  color?: string;
  strokeWidth?: number;
  style?: ViewStyle;
}

export function MailIcon({ size, width, height, color = '#333333', strokeWidth = 2, style }: MailIconProps) {
  // If width/height are provided, use them; otherwise use size for both
  const iconWidth = width ?? size ?? 24;
  const iconHeight = height ?? size ?? 24;
  
  return (
    <View style={[styles.container, { width: iconWidth, height: iconHeight }, style]}>
      <MailSvg
        width={iconWidth}
        height={iconHeight}
        color={color}
        strokeWidth={strokeWidth}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default MailIcon;